import { atom } from 'jotai';
import type { AuthSource } from '~/modules/user/type';
export const uiStateAtomLoginModalOpened = atom(false);
export const uiStateAtomLoginModalAuthSource = atom<AuthSource | null>(null);
export const uiStateAtomLoginModalRedirect = atom<string | undefined>(
    undefined,
);
export const uiStateAtomLoginModalTitle = atom<string | undefined>(undefined);
